'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MARKETING_SALES = exports.MARKETING_SALES = 'marketing-sales';
var IGS_NURTURING = exports.IGS_NURTURING = 'igs-nurturing';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/constants/RepTypes.js
// module id = 282
// module chunks = 3 4 5